const COLORS = ['#9D51FF', '#DA1EB0', '#ED1C24', '#5C9F05', '#019C9C', '#5278FF'];

export default COLORS;
